import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/updateProfile';
import query from 'client/queries/user';

export default function useUpdateProfile() {

  const options = {
    refetchQueries: [{ query }]
  };

  return useMutation(mutation, options);
}
